/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function isFifteenFootVariant(variant) {
    if (!variant) {
      return false;
    }

    var values = [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ].filter(Boolean).join(' ');

    return /(^|[^0-9])15\s*(x|×|'|ft|feet)/i.test(values);
  }

  function isFifteenFootText(value) {
    return /(^|[^0-9])15\s*(x|×|'|ft|feet)/i.test(value || '');
  }

  function getSelectedSizeText(form) {
    var selector = form.querySelector('.product-form__single-selector, select[name^="option"]');

    if (!selector || selector.selectedIndex < 0) {
      return '';
    }

    return selector.options[selector.selectedIndex].text;
  }

  function getVariantFromForm(form) {
    var section = form.closest('[data-section-type="product"]');
    var variantInput = form.querySelector('[name="id"]');

    if (!section || !variantInput) {
      return null;
    }

    var productJson = section.querySelector('[data-product-json]');

    if (!productJson) {
      return null;
    }

    try {
      var productData = JSON.parse(productJson.textContent);
      var variantId = parseInt(variantInput.value, 10);
      return productData.product.variants.find(function (variant) {
        return variant.id === variantId;
      });
    } catch (error) {
      return null;
    }
  }

  function updatePolicyAcknowledgement(form, variant) {
    if (!form) {
      return;
    }

    var acknowledgement = form.querySelector('[data-policy-acknowledgement]');

    if (!acknowledgement) {
      return;
    }

    var checkbox = acknowledgement.querySelector('input[type="checkbox"]');
    var currentVariant = variant || getVariantFromForm(form);
    var requiresAcknowledgement = isFifteenFootVariant(currentVariant) || isFifteenFootText(getSelectedSizeText(form));

    acknowledgement.classList.toggle('product-policy-acknowledgement--hidden', !requiresAcknowledgement);

    if (checkbox) {
      checkbox.required = requiresAcknowledgement;

      if (!requiresAcknowledgement) {
        checkbox.checked = false;
      }
    }
  }

  function updateAllPolicyAcknowledgements() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      updatePolicyAcknowledgement(form);
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[data-section-type="product"]') : null;

    if (!section) {
      section = document.querySelector('[data-section-type="product"]');
    }

    if (!section) {
      return;
    }

    section.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      updatePolicyAcknowledgement(form, event.detail.variant);
    });
  });

  document.addEventListener('change', function (event) {
    var selector = event.target.closest('.product-form__single-selector, form[action*="/cart/add"] select');

    if (!selector) {
      return;
    }

    var form = selector.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    updatePolicyAcknowledgement(form);
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-action="add-to-cart"]');

    if (!target) {
      return;
    }

    var form = target.closest('form[action*="/cart/add"]');

    if (!form) {
      return;
    }

    updatePolicyAcknowledgement(form);

    var requiredCheckbox = form.querySelector('[data-policy-acknowledgement] input[required]');

    if (requiredCheckbox && !requiredCheckbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      requiredCheckbox.reportValidity();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPolicyAcknowledgements);
  } else {
    updateAllPolicyAcknowledgements();
  }
})();

/* Codex preview: guided homeowner flow - 2026-05-27 */
(function () {
  if (window.ATUGuidedFlowPreview) {
    return;
  }

  window.ATUGuidedFlowPreview = true;

  var CALCULATOR_PATH = '/pages/turf-calculator';
  var COLLECTION_PATH = '/collections/all-turf-products';
  var PHONE_DISPLAY = '626-684-2019';
  var PHONE_TEL = '16266842019';
  var STORAGE_KEY = 'turfCalculatorState';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function isHomePage() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return path === '' || path === '/';
  }

  function isProductPage() {
    return /^\/products\//.test(window.location.pathname);
  }

  function addStyles() {
    if (document.getElementById('atu-guided-flow-styles')) {
      return;
    }

    var css = [
      '.atu-guide{--atu-green:#17633a;--atu-green-dark:#0f4728;--atu-ink:#1f2d24;--atu-muted:#58675d;--atu-line:#dbe6dc;--atu-bg:#f7f9f5;--atu-soft:#eef5ee;--atu-alert:#fff5d6;color:var(--atu-ink);font-family:inherit;letter-spacing:0;}',
      '.atu-guide *{box-sizing:border-box;letter-spacing:0;}',
      '.atu-guide a{color:inherit;}',
      '.atu-guide__band{background:var(--atu-bg);border-top:1px solid var(--atu-line);border-bottom:1px solid var(--atu-line);}',
      '.atu-guide__wrap{max-width:1180px;margin:0 auto;padding:34px 20px;}',
      '.atu-guide__layout{display:grid;grid-template-columns:minmax(0,1.08fr) minmax(320px,.92fr);gap:28px;align-items:start;}',
      '.atu-guide__eyebrow{display:inline-flex;align-items:center;min-height:28px;padding:5px 10px;border:1px solid rgba(23,99,58,.22);border-radius:6px;background:#fff;color:var(--atu-green-dark);font-size:12px;font-weight:800;text-transform:uppercase;}',
      '.atu-guide__title{margin:14px 0 10px;color:var(--atu-ink);font-size:28px;line-height:1.12;font-weight:850;}',
      '.atu-guide__copy{max-width:720px;margin:0;color:var(--atu-muted);font-size:15px;line-height:1.58;}',
      '.atu-guide__steps{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin-top:20px;}',
      '.atu-guide__step{min-height:72px;padding:13px 14px;border:1px solid var(--atu-line);border-radius:8px;background:#fff;}',
      '.atu-guide__step strong{display:block;margin-bottom:4px;color:var(--atu-green-dark);font-size:13px;line-height:1.2;}',
      '.atu-guide__step span{display:block;color:var(--atu-muted);font-size:12px;line-height:1.35;}',
      '.atu-guide__projects{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-top:22px;}',
      '.atu-guide__project{width:100%;min-height:74px;padding:13px;border:1px solid var(--atu-line);border-radius:8px;background:#fff;text-align:left;color:var(--atu-ink);cursor:pointer;transition:border-color .18s ease,box-shadow .18s ease,background .18s ease;}',
      '.atu-guide__project:hover,.atu-guide__project.is-active{border-color:rgba(23,99,58,.55);background:var(--atu-soft);box-shadow:0 0 0 2px rgba(23,99,58,.08);}',
      '.atu-guide__project strong{display:block;margin:0 0 4px;font-size:14px;line-height:1.2;}',
      '.atu-guide__project span{display:block;color:var(--atu-muted);font-size:12px;line-height:1.35;}',
      '.atu-guide__tool{border:1px solid var(--atu-line);border-radius:8px;background:#fff;box-shadow:0 10px 26px rgba(31,45,36,.08);}',
      '.atu-guide__tool-inner{padding:20px;}',
      '.atu-guide__tool-title{margin:0 0 4px;font-size:17px;line-height:1.25;font-weight:850;color:var(--atu-ink);}',
      '.atu-guide__tool-copy{margin:0 0 14px;color:var(--atu-muted);font-size:13px;line-height:1.45;}',
      '.atu-guide__fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;}',
      '.atu-guide__field label{display:block;margin-bottom:5px;color:var(--atu-muted);font-size:12px;font-weight:800;}',
      '.atu-guide__field input{width:100%;height:44px;border:1px solid #cbd8cf;border-radius:6px;background:#fff;color:var(--atu-ink);font-size:16px;padding:0 11px;}',
      '.atu-guide__field input:focus{outline:2px solid rgba(23,99,58,.24);outline-offset:1px;border-color:var(--atu-green);}',
      '.atu-guide__result{margin:14px 0;padding:13px;border:1px solid rgba(23,99,58,.22);border-radius:8px;background:#f5fbf4;}',
      '.atu-guide__result strong{display:block;margin-bottom:4px;color:var(--atu-green-dark);font-size:15px;line-height:1.3;}',
      '.atu-guide__result span{display:block;color:var(--atu-muted);font-size:12px;line-height:1.42;}',
      '.atu-guide__actions{display:flex;flex-wrap:wrap;gap:10px;align-items:center;}',
      '.atu-guide__button{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:11px 15px;border-radius:6px;border:1px solid var(--atu-green);font-size:14px;font-weight:850;line-height:1.18;text-align:center;text-decoration:none;white-space:normal;cursor:pointer;}',
      '.atu-guide__button--primary{background:var(--atu-green);color:#fff;}',
      '.atu-guide__button--primary:hover{background:var(--atu-green-dark);color:#fff;}',
      '.atu-guide__button--secondary{background:#fff;color:var(--atu-green-dark);}',
      '.atu-guide__button--secondary:hover{background:var(--atu-soft);}',
      '.atu-guide__button--plain{border-color:transparent;background:transparent;color:var(--atu-green-dark);text-decoration:underline;text-underline-offset:3px;padding-left:4px;padding-right:4px;}',
      '.atu-guide__small{margin:12px 0 0;color:var(--atu-muted);font-size:12px;line-height:1.45;}',
      '.atu-guide__small a{font-weight:850;color:var(--atu-green-dark);}',
      '.atu-guide__product{margin:0 0 14px;}',
      '.atu-guide__product-panel{border:1px solid rgba(23,99,58,.24);border-radius:8px;background:#f7f9f5;box-shadow:0 8px 22px rgba(31,45,36,.06);}',
      '.atu-guide__product-inner{padding:17px;}',
      '.atu-guide__product-top{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-bottom:9px;}',
      '.atu-guide__badge{display:inline-flex;align-items:center;min-height:24px;padding:4px 8px;border-radius:6px;background:#fff;border:1px solid rgba(23,99,58,.24);color:var(--atu-green-dark);font-size:11px;font-weight:850;text-transform:uppercase;}',
      '.atu-guide__product-title{margin:0 0 7px;color:var(--atu-ink);font-size:18px;line-height:1.25;font-weight:850;}',
      '.atu-guide__product-copy{margin:0 0 13px;color:var(--atu-muted);font-size:13px;line-height:1.48;}',
      '.atu-guide__product .atu-guide__fields{grid-template-columns:repeat(2,minmax(110px,1fr));}',
      '.atu-guide__variant-hint{margin:12px 0 0;padding:10px 11px;border-radius:6px;background:var(--atu-alert);color:#564512;font-size:12px;line-height:1.45;}',
      '.atu-guide-pulse{box-shadow:0 0 0 4px rgba(23,99,58,.18)!important;transition:box-shadow .2s ease;}',
      '@media (max-width:900px){.atu-guide__layout{grid-template-columns:1fr;}.atu-guide__steps{grid-template-columns:1fr;}.atu-guide__tool{box-shadow:none;}}',
      '@media (max-width:620px){.atu-guide__wrap{padding:24px 16px;}.atu-guide__title{font-size:22px;line-height:1.18;}.atu-guide__projects,.atu-guide__fields,.atu-guide__product .atu-guide__fields{grid-template-columns:1fr;}.atu-guide__button{width:100%;}.atu-guide__actions{align-items:stretch;}.atu-guide__project{min-height:68px;}}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'atu-guided-flow-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function numberFrom(root, fieldName) {
    var field = root.querySelector('[data-atu-field="' + fieldName + '"]');
    if (!field) {
      return 0;
    }

    var value = parseFloat(field.value);
    return isFinite(value) && value > 0 ? value : 0;
  }

  function formatFeet(value) {
    var rounded = Math.round(value * 10) / 10;
    return String(rounded).replace(/\.0$/, '');
  }

  function rollRecommendation(length, width) {
    if (!length || !width) {
      return {
        title: 'Enter length and width to see the next step.',
        note: 'The full calculator will confirm waste, grass direction, and whether one 15 ft roll works.'
      };
    }

    var shortSide = Math.min(length, width);
    var longSide = Math.max(length, width);
    var area = Math.round(length * width);

    if (shortSide > 15) {
      return {
        title: 'This area is wider than one 15 ft roll.',
        note: area + ' sq ft entered. The calculator will help with seams, multiple rolls, or a custom plan.'
      };
    }

    var rawRollLength = Math.ceil(longSide);
    var rollLength = Math.max(20, Math.min(100, rawRollLength));
    var title = 'Start around a 15 x ' + rollLength + ' ft roll.';
    var note = area + ' sq ft entered. Use the calculator next so the roll direction and final option match before checkout.';

    if (rawRollLength < 20) {
      note = area + ' sq ft entered. Most full roll options start around 15 x 20 ft; the calculator will confirm the best fit.';
    }

    if (rawRollLength > 100) {
      title = 'This may need more than one roll.';
      note = area + ' sq ft entered. The calculator will route you before you choose a product option.';
    }

    return { title: title, note: note };
  }

  function projectFrom(root) {
    return root.getAttribute('data-atu-project') || 'lawn';
  }

  function buildCalculatorParams(root, source, productHandle) {
    var length = numberFrom(root, 'length');
    var width = numberFrom(root, 'width');
    var params = new URLSearchParams();
    var project = projectFrom(root);

    params.set('source', source);
    params.set('shape', 'rectangle');
    params.set('project', project);

    if (productHandle) {
      params.set('product', productHandle);
    }

    if (length && width) {
      params.set('length', formatFeet(length));
      params.set('width', formatFeet(width));
      params.set('side1', formatFeet(length));
      params.set('side2', formatFeet(width));
      params.set('project_area', String(Math.round(length * width)));
    }

    return params;
  }

  function calculatorUrl(params) {
    var query = params.toString();
    return CALCULATOR_PATH + (query ? '?' + query : '');
  }

  function saveCalculatorState(params) {
    var storageParams = new URLSearchParams();
    ['shape', 'side1', 'side2', 'length', 'width', 'project_area', 'keep_direction', 'priority'].forEach(function (key) {
      var value = params.get(key);
      if (value !== null && value !== '') {
        storageParams.set(key, value);
      }
    });

    if (!storageParams.get('side1') || !storageParams.get('side2')) {
      return;
    }

    try {
      window.sessionStorage.setItem(STORAGE_KEY, storageParams.toString());
    } catch (error) {
      // URL parameters still carry the calculator state when browser storage is unavailable.
    }
  }

  function bindCalculator(root, source, productHandle) {
    var resultTitle = root.querySelector('[data-atu-result]');
    var resultNote = root.querySelector('[data-atu-result-note]');
    var link = root.querySelector('[data-atu-calc-link]');
    var form = root.querySelector('[data-atu-form]');

    function refresh() {
      var recommendation = rollRecommendation(numberFrom(root, 'length'), numberFrom(root, 'width'));
      var params = buildCalculatorParams(root, source, productHandle);

      if (resultTitle) {
        resultTitle.textContent = recommendation.title;
      }
      if (resultNote) {
        resultNote.textContent = recommendation.note;
      }
      if (link) {
        link.setAttribute('href', calculatorUrl(params));
      }
    }

    root.querySelectorAll('[data-atu-field]').forEach(function (field) {
      field.addEventListener('input', refresh);
    });

    root.querySelectorAll('[data-atu-project]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.setAttribute('data-atu-project', button.getAttribute('data-atu-project'));
        root.querySelectorAll('[data-atu-project]').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        refresh();
      });
    });

    if (link) {
      link.addEventListener('click', function () {
        saveCalculatorState(buildCalculatorParams(root, source, productHandle));
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var params = buildCalculatorParams(root, source, productHandle);
        saveCalculatorState(params);
        window.location.href = calculatorUrl(params);
      });
    }

    refresh();
  }

  function homeGuideMarkup() {
    return '' +
      '<section class="atu-guide atu-guide__band" data-atu-guide="home" data-atu-project="lawn">' +
        '<div class="atu-guide__wrap">' +
          '<div class="atu-guide__layout">' +
            '<div>' +
              '<div class="atu-guide__eyebrow">Homeowner buying path</div>' +
              '<h2 class="atu-guide__title">Measure first. Then buy the right 15 ft roll.</h2>' +
              '<p class="atu-guide__copy">Artificial turf is usually sold by a 15 ft wide roll. Start with your project type and yard size, use the calculator, then add the matching 15 x ___ ft option to cart.</p>' +
              '<div class="atu-guide__steps" aria-label="Buying steps">' +
                '<div class="atu-guide__step"><strong>1. Pick project</strong><span>Lawn, dogs, putting green, or play area.</span></div>' +
                '<div class="atu-guide__step"><strong>2. Calculate roll</strong><span>Confirm size, direction, and waste.</span></div>' +
                '<div class="atu-guide__step"><strong>3. Add to cart</strong><span>Choose the matching 15 x ___ ft option.</span></div>' +
              '</div>' +
              '<div class="atu-guide__projects" aria-label="Project type">' +
                '<button class="atu-guide__project is-active" type="button" data-atu-project="lawn"><strong>Front/back yard</strong><span>Natural lawn look</span></button>' +
                '<button class="atu-guide__project" type="button" data-atu-project="dog"><strong>Dog yard</strong><span>Drainage and odor control</span></button>' +
                '<button class="atu-guide__project" type="button" data-atu-project="putting"><strong>Putting green</strong><span>Short pile and direction</span></button>' +
                '<button class="atu-guide__project" type="button" data-atu-project="play"><strong>Play/gym area</strong><span>Comfort and traffic</span></button>' +
              '</div>' +
            '</div>' +
            '<div class="atu-guide__tool">' +
              '<div class="atu-guide__tool-inner">' +
                '<h3 class="atu-guide__tool-title">Start with yard size</h3>' +
                '<p class="atu-guide__tool-copy">Enter rough dimensions now. The next page will refine the roll choice before checkout.</p>' +
                '<form data-atu-form>' +
                  '<div class="atu-guide__fields">' +
                    '<div class="atu-guide__field"><label for="atu-home-length">Length (ft)</label><input id="atu-home-length" data-atu-field="length" inputmode="decimal" type="number" min="1" step="0.1" placeholder="30"></div>' +
                    '<div class="atu-guide__field"><label for="atu-home-width">Width (ft)</label><input id="atu-home-width" data-atu-field="width" inputmode="decimal" type="number" min="1" step="0.1" placeholder="15"></div>' +
                  '</div>' +
                  '<div class="atu-guide__result" aria-live="polite"><strong data-atu-result></strong><span data-atu-result-note></span></div>' +
                  '<div class="atu-guide__actions">' +
                    '<a class="atu-guide__button atu-guide__button--primary" href="' + CALCULATOR_PATH + '" data-atu-calc-link>Calculate my roll</a>' +
                    '<a class="atu-guide__button atu-guide__button--secondary" href="' + COLLECTION_PATH + '">Shop after measuring</a>' +
                  '</div>' +
                '</form>' +
                '<p class="atu-guide__small">Need a second opinion? Call or text <a href="tel:' + PHONE_TEL + '">' + PHONE_DISPLAY + '</a> with your measurements.</p>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</section>';
  }

  function insertHomeGuide() {
    if (!isHomePage() || document.querySelector('[data-atu-guide="home"]')) {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML = homeGuideMarkup();
    var guide = wrapper.firstElementChild;
    var main = document.querySelector('main') || document.body;
    var hero = document.querySelector('[id*="__slideshow"]') || document.querySelector('.shopify-section--slideshow');

    if (!hero) {
      var slideshow = document.querySelector('.slideshow');
      hero = slideshow && slideshow.closest ? slideshow.closest('.shopify-section') : null;
    }

    if (hero && hero.parentNode) {
      hero.parentNode.insertBefore(guide, hero.nextSibling);
    } else if (main.firstElementChild) {
      main.insertBefore(guide, main.firstElementChild.nextSibling);
    } else {
      main.appendChild(guide);
    }

    bindCalculator(guide, 'homeowner_guide', '');
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^\/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function isAdLanding() {
    var params = new URLSearchParams(window.location.search);
    if (params.has('gclid') || params.has('gbraid') || params.has('wbraid')) {
      return true;
    }

    var source = (params.get('utm_source') || '').toLowerCase();
    var medium = (params.get('utm_medium') || '').toLowerCase();
    return source.indexOf('google') !== -1 || medium === 'cpc' || medium === 'paid';
  }

  function selectedVariantText() {
    var select = document.querySelector('form[action*="/cart/add"] .product-form__single-selector, form[action*="/cart/add"] select[name^="option"]');
    if (select && select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
      return select.options[select.selectedIndex].textContent.trim();
    }

    var selectedLabel = document.querySelector('form[action*="/cart/add"] .product-form__selected-value');
    return selectedLabel ? selectedLabel.textContent.trim() : '';
  }

  function updateVariantHint(root) {
    var hint = root.querySelector('[data-atu-variant-hint]');
    if (!hint) {
      return;
    }

    var selected = selectedVariantText();
    if (!selected) {
      hint.textContent = 'Choose Sample only for color and feel. For a yard order, calculate first and choose the matching 15 x ___ ft roll.';
      return;
    }

    if (/^sample$/i.test(selected)) {
      hint.textContent = 'Selected now: Sample. Samples are for color and feel; yard orders need a calculated 15 x ___ ft roll option.';
    } else {
      hint.textContent = 'Selected now: ' + selected + '. Make sure this matches the calculator result before adding to cart.';
    }
  }

  function productGuideMarkup(adLanding) {
    var badge = adLanding ? 'Google ad landing step 1' : 'Roll size step 1';

    return '' +
      '<div class="atu-guide atu-guide__product" data-atu-guide="product" data-atu-project="lawn">' +
        '<div class="atu-guide__product-panel">' +
          '<div class="atu-guide__product-inner">' +
            '<div class="atu-guide__product-top"><span class="atu-guide__badge">' + badge + '</span></div>' +
            '<h3 class="atu-guide__product-title">Calculate before choosing a 15 x ___ roll</h3>' +
            '<p class="atu-guide__product-copy">This product starts on Sample so you can check the feel. For a yard order, measure first, use the calculator, then come back and pick the closest full roll option.</p>' +
            '<div class="atu-guide__fields">' +
              '<div class="atu-guide__field"><label for="atu-product-length">Length (ft)</label><input id="atu-product-length" data-atu-field="length" inputmode="decimal" type="number" min="1" step="0.1" placeholder="30"></div>' +
              '<div class="atu-guide__field"><label for="atu-product-width">Width (ft)</label><input id="atu-product-width" data-atu-field="width" inputmode="decimal" type="number" min="1" step="0.1" placeholder="15"></div>' +
            '</div>' +
            '<div class="atu-guide__result" aria-live="polite"><strong data-atu-result></strong><span data-atu-result-note></span></div>' +
            '<div class="atu-guide__actions">' +
              '<a class="atu-guide__button atu-guide__button--primary" href="' + CALCULATOR_PATH + '" data-atu-calc-link>Use calculator</a>' +
              '<button class="atu-guide__button atu-guide__button--secondary" type="button" data-atu-scroll-variants>I know my size</button>' +
            '</div>' +
            '<p class="atu-guide__variant-hint" data-atu-variant-hint></p>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function scrollToVariants() {
    var target = document.querySelector('.product-form__variants') || document.querySelector('form[action*="/cart/add"]');
    if (!target) {
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.add('atu-guide-pulse');
    window.setTimeout(function () {
      target.classList.remove('atu-guide-pulse');
    }, 1800);
  }

  function insertProductGuide() {
    if (!isProductPage() || document.querySelector('[data-atu-guide="product"]')) {
      return;
    }

    var form = document.querySelector('form[action*="/cart/add"]');
    var anchor = form || document.querySelector('.product-meta');
    if (!anchor || !anchor.parentNode) {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML = productGuideMarkup(isAdLanding());
    var guide = wrapper.firstElementChild;

    anchor.parentNode.insertBefore(guide, anchor);
    bindCalculator(guide, isAdLanding() ? 'google_product_guide' : 'product_guide', productHandle());
    updateVariantHint(guide);

    var scrollButton = guide.querySelector('[data-atu-scroll-variants]');
    if (scrollButton) {
      scrollButton.addEventListener('click', scrollToVariants);
    }

    document.addEventListener('variant:changed', function () {
      updateVariantHint(guide);
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('form[action*="/cart/add"]')) {
        window.setTimeout(function () {
          updateVariantHint(guide);
        }, 0);
      }
    });
  }

  onReady(function () {
    addStyles();
    insertHomeGuide();
    insertProductGuide();
  });
})();

/* Codex preview: guided flow button contrast fix */
(function () {
  function applyGuidedFlowButtonFix() {
    if (document.getElementById('atu-guided-flow-button-fix')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'atu-guided-flow-button-fix';
    style.textContent = '.atu-guide .atu-guide__button--primary,.atu-guide .atu-guide__button--primary:visited{background:#17633a!important;border-color:#17633a!important;color:#fff!important;}.atu-guide .atu-guide__button--primary:hover{background:#0f4728!important;color:#fff!important;}.atu-guide .atu-guide__button--secondary,.atu-guide .atu-guide__button--secondary:visited{color:#0f4728!important;}';
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGuidedFlowButtonFix);
  } else {
    applyGuidedFlowButtonFix();
  }
})();

/* Codex preview: show prices on project recommendation cards */
(function () {
  var STYLE_ID = 'atu-project-card-price-styles';
  var CACHE_PREFIX = 'atuProjectCardPrice:';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function addPriceStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.ai-turf-card__price{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;margin-top:10px;padding-top:10px;border-top:1px solid rgba(31,45,36,.12);color:#17633a;font-style:normal;}',
      '.ai-turf-card__price strong{font-size:15px;line-height:1.2;font-weight:850;color:#17633a;}',
      '.ai-turf-card__price small{font-size:11px;line-height:1.35;font-weight:700;color:#58675d;}',
      '.ai-turf-card__price--loading strong{color:#58675d;}'
    ].join('');
    document.head.appendChild(style);
  }

  function handleFromHref(href) {
    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^\/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function variantArea(variant) {
    var text = [variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean).join(' ');
    if (/sample/i.test(text)) {
      return 0;
    }

    var match = text.match(/(\d+(?:\.\d+)?)\s*(?:x|×)\s*(\d+(?:\.\d+)?)/i);
    if (!match) {
      return 0;
    }

    var width = parseFloat(match[1]);
    var length = parseFloat(match[2]);
    return width > 0 && length > 0 ? width * length : 0;
  }

  function priceInfo(product) {
    var bestPerSqFt = null;
    var bestRoll = null;

    (product.variants || []).forEach(function (variant) {
      if (variant.available === false) {
        return;
      }

      var area = variantArea(variant);
      if (!area || !variant.price) {
        return;
      }

      var perSqFt = variant.price / area;
      if (bestPerSqFt === null || perSqFt < bestPerSqFt) {
        bestPerSqFt = perSqFt;
      }
      if (bestRoll === null || variant.price < bestRoll) {
        bestRoll = variant.price;
      }
    });

    if (bestPerSqFt !== null) {
      return {
        label: 'From ' + money(bestPerSqFt) + '/sq ft',
        note: 'Use calculator for exact roll price'
      };
    }

    var productPrice = Number(product.price_min || product.price || 0);
    if (productPrice > 0) {
      return {
        label: 'From ' + money(productPrice),
        note: 'Check sizes on product page'
      };
    }

    return null;
  }

  function readCache(handle) {
    try {
      var cached = window.sessionStorage.getItem(CACHE_PREFIX + handle);
      return cached ? JSON.parse(cached) : null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(handle, info) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify(info));
    } catch (error) {
      // Fresh product data will be fetched again when storage is unavailable.
    }
  }

  function ensurePriceNode(card) {
    var existing = card.querySelector('.ai-turf-card__price');
    if (existing) {
      return existing;
    }

    var node = document.createElement('span');
    node.className = 'ai-turf-card__price ai-turf-card__price--loading';
    node.innerHTML = '<strong>Checking price</strong><small>Loading roll price</small>';

    var body = card.querySelector('.ai-turf-card__body') || card;
    body.appendChild(node);
    return node;
  }

  function renderPrice(card, info) {
    if (!info) {
      return;
    }

    var node = ensurePriceNode(card);
    node.classList.remove('ai-turf-card__price--loading');
    node.innerHTML = '<strong>' + info.label + '</strong><small>' + info.note + '</small>';
  }

  function fetchProductPrice(handle) {
    var cached = readCache(handle);
    if (cached) {
      return Promise.resolve(cached);
    }

    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product not found');
        }
        return response.json();
      })
      .then(function (product) {
        var info = priceInfo(product);
        if (info) {
          writeCache(handle, info);
        }
        return info;
      })
      .catch(function () {
        return null;
      });
  }

  function hydrateProjectCardPrices() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.ai-turf-card[href*="/products/"]'));
    if (!cards.length) {
      return;
    }

    addPriceStyles();

    cards.forEach(function (card) {
      if (card.getAttribute('data-atu-price-loaded') === 'true') {
        return;
      }

      var handle = handleFromHref(card.getAttribute('href') || '');
      if (!handle) {
        return;
      }

      card.setAttribute('data-atu-price-loaded', 'true');
      ensurePriceNode(card);
      fetchProductPrice(handle).then(function (info) {
        renderPrice(card, info);
      });
    });
  }

  onReady(hydrateProjectCardPrices);
  document.addEventListener('shopify:section:load', hydrateProjectCardPrices);
})();

/* Codex preview: project card prices after calculator link rewrite */
(function () {
  var STYLE_ID = 'atu-project-card-price-styles';
  var CACHE_PREFIX = 'atuProjectCardPriceV2:';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function styles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '.ai-turf-card__price{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;margin-top:10px;padding-top:10px;border-top:1px solid rgba(31,45,36,.12);color:#17633a;font-style:normal}.ai-turf-card__price strong{font-size:15px;line-height:1.2;font-weight:850;color:#17633a}.ai-turf-card__price small{font-size:11px;line-height:1.35;font-weight:700;color:#58675d}.ai-turf-card__price--loading strong{color:#58675d}';
    document.head.appendChild(style);
  }

  function handleFromCard(card) {
    try {
      var url = new URL(card.getAttribute('href') || '', window.location.origin);
      var queryHandle = url.searchParams.get('product');
      if (queryHandle) {
        return queryHandle;
      }
      var match = url.pathname.match(/\/products\/([^\/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function areaFromVariant(variant) {
    var text = [variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean).join(' ');
    if (/sample/i.test(text)) return 0;
    var match = text.match(/(\d+(?:\.\d+)?)\s*(?:x|×)\s*(\d+(?:\.\d+)?)/i);
    if (!match) return 0;
    var a = parseFloat(match[1]);
    var b = parseFloat(match[2]);
    return a > 0 && b > 0 ? a * b : 0;
  }

  function infoFromProduct(product) {
    var best = null;
    (product.variants || []).forEach(function (variant) {
      if (variant.available === false || !variant.price) return;
      var area = areaFromVariant(variant);
      if (!area) return;
      var perSqFt = variant.price / area;
      if (best === null || perSqFt < best) best = perSqFt;
    });
    if (best !== null) {
      return { label: 'From ' + money(best) + '/sq ft', note: 'Use calculator for exact roll price' };
    }
    var fallback = Number(product.price_min || product.price || 0);
    return fallback > 0 ? { label: 'From ' + money(fallback), note: 'Check sizes on product page' } : null;
  }

  function priceNode(card) {
    var node = card.querySelector('.ai-turf-card__price');
    if (node) return node;
    node = document.createElement('span');
    node.className = 'ai-turf-card__price ai-turf-card__price--loading';
    node.innerHTML = '<strong>Checking price</strong><small>Loading roll price</small>';
    (card.querySelector('.ai-turf-card__body') || card).appendChild(node);
    return node;
  }

  function load(handle) {
    try {
      var cached = window.sessionStorage.getItem(CACHE_PREFIX + handle);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (error) {}

    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        var info = product ? infoFromProduct(product) : null;
        if (info) {
          try { window.sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify(info)); } catch (error) {}
        }
        return info;
      })
      .catch(function () { return null; });
  }

  function hydrate() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.ai-turf-card'));
    if (!cards.length) return;
    styles();
    cards.forEach(function (card) {
      if (card.getAttribute('data-atu-price-v2') === 'true') return;
      var handle = handleFromCard(card);
      if (!handle) return;
      card.setAttribute('data-atu-price-v2', 'true');
      var node = priceNode(card);
      load(handle).then(function (info) {
        if (!info) return;
        node.classList.remove('ai-turf-card__price--loading');
        node.innerHTML = '<strong>' + info.label + '</strong><small>' + info.note + '</small>';
      });
    });
  }

  ready(hydrate);
  window.setTimeout(hydrate, 800);
  window.setTimeout(hydrate, 2200);
  document.addEventListener('shopify:section:load', hydrate);
})();

/* Codex preview: collection fallback prices for every project recommendation card */
(function () {
  var STYLE_ID = 'ai-turf-card-price-style';
  var MONEY = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var productCache = {};
  var collectionCache = {};

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.ai-turf-card__price{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;margin-top:10px;padding-top:10px;border-top:1px solid rgba(31,45,36,.12);color:#17633a;font-style:normal}',
      '.ai-turf-card__price strong{font-size:15px;line-height:1.2;font-weight:850;color:#17633a}',
      '.ai-turf-card__price small{font-size:11px;line-height:1.35;font-weight:700;color:#58675d}'
    ].join('');
    document.head.appendChild(style);
  }

  function centsFrom(value) {
    if (value == null || value === '') return 0;
    var raw = String(value).replace(/[^0-9.]/g, '');
    if (!raw) return 0;
    var n = Number(raw);
    if (!isFinite(n) || n <= 0) return 0;
    return n > 1000 ? Math.round(n) : Math.round(n * 100);
  }

  function formatCents(cents) {
    return MONEY.format(cents / 100).replace(/\.00$/, '');
  }

  function getCardLink(card) {
    return card && card.getAttribute('href') ? card.getAttribute('href') : '';
  }

  function urlFromHref(href) {
    try {
      return new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function getProductHandle(href) {
    var url = urlFromHref(href);
    if (!url) return '';
    var productParam = url.searchParams.get('product');
    if (productParam) return productParam;
    var productMatch = url.pathname.match(/\/products\/([^/?#]+)/);
    return productMatch ? productMatch[1] : '';
  }

  function getCollectionHandle(href) {
    var url = urlFromHref(href);
    if (!url) return '';
    var collectionMatch = url.pathname.match(/\/collections\/([^/?#]+)/);
    return collectionMatch ? collectionMatch[1] : '';
  }

  function ensurePriceNode(card) {
    var existing = card.querySelector('.ai-turf-card__price');
    if (existing) return existing;
    var node = document.createElement('span');
    node.className = 'ai-turf-card__price';
    node.innerHTML = '<strong>Loading price</strong><small>Checking current products</small>';
    card.appendChild(node);
    return node;
  }

  function setPrice(node, main, note) {
    node.innerHTML = '<strong>' + main + '</strong><small>' + note + '</small>';
  }

  function lowestProductVariantCents(product) {
    if (!product || !product.variants) return 0;
    return product.variants.reduce(function (lowest, variant) {
      var title = String(variant.title || '').toLowerCase();
      var option1 = String(variant.option1 || '').toLowerCase();
      if (title === 'sample' || option1 === 'sample' || title.indexOf('sample') !== -1) return lowest;
      var cents = centsFrom(variant.price);
      if (!cents) return lowest;
      return lowest ? Math.min(lowest, cents) : cents;
    }, 0);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function fetchCollectionLowest(handle) {
    if (!handle) return Promise.resolve(0);
    if (!collectionCache[handle]) {
      collectionCache[handle] = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50')
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          var products = data && data.products ? data.products : [];
          return products.reduce(function (lowest, product) {
            var cents = lowestProductVariantCents(product);
            if (!cents && product && product.price_min) cents = centsFrom(product.price_min);
            if (!cents) return lowest;
            return lowest ? Math.min(lowest, cents) : cents;
          }, 0);
        })
        .catch(function () { return 0; });
    }
    return collectionCache[handle];
  }

  function hydrateCard(card) {
    if (!card || card.querySelector('.ai-turf-card__price')) return;
    if (card.dataset.atuPriceV3 === 'done') return;

    var href = getCardLink(card);
    var productHandle = getProductHandle(href);
    var collectionHandle = getCollectionHandle(href);
    if (!productHandle && !collectionHandle) return;

    card.dataset.atuPriceV3 = 'done';
    var node = ensurePriceNode(card);

    if (productHandle) {
      fetchProduct(productHandle).then(function (product) {
        var cents = lowestProductVariantCents(product);
        if (cents) {
          setPrice(node, 'From ' + formatCents(cents) + '/sq ft', 'Use calculator for exact roll price');
        } else if (collectionHandle) {
          return fetchCollectionLowest(collectionHandle).then(function (collectionCents) {
            if (collectionCents) setPrice(node, 'From ' + formatCents(collectionCents), 'Check available sizes');
            else node.remove();
          });
        } else {
          node.remove();
        }
      });
      return;
    }

    fetchCollectionLowest(collectionHandle).then(function (cents) {
      if (cents) setPrice(node, 'From ' + formatCents(cents), 'Check available sizes before checkout');
      else node.remove();
    });
  }

  function hydrateAllCards() {
    addStyle();
    document.querySelectorAll('.ai-turf-card').forEach(hydrateCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAllCards);
  } else {
    hydrateAllCards();
  }
  window.addEventListener('load', hydrateAllCards);
  setTimeout(hydrateAllCards, 1000);
  setTimeout(hydrateAllCards, 2500);
})();
